import { MobiErrorRes } from '..'

export interface CreateInvoiceReq {
  isdn?: string
  type?: string
  products?: CreateInvoiceProduct[]
  customerType?: 'CORPORATE' | 'CONSUMER'
  languageCode?: 'mn' | 'en'
  currency?: 'USD' | '0'
  vatEmail?: string
  corpId?: string
  device?: 'WEB' | 'MOBILE'
  redirectUrl?: string
  applyPromo?: boolean
  fbp?: string
  fbc?: string
}
export interface CreateInvoiceProduct {
  productCode: string
  productType: string
  quantity?: number
  price?: number
}
export enum ProductType {
  TOPUP = 'TOPUP',
  DATA = 'DATA',
  BILL = 'BILL',
  ESIM = 'ESIM',
  NEWNUMBER = 'NEWNUMBER',
  PACKAGESHIFT = 'PACKAGESHIFT',
  HANDSETDTI = 'HANDSETDTI',
  TOURISTSIM = 'TOURISTSIM',
  TOURISTSIMTOPUP = 'TOURISTSIMTOPUP',
}
export interface CreateInvoiceRes extends MobiErrorRes {
  invoiceId: string
  redirectUrl: string
}

export interface Invoice {
  isdn: string
  amountDetails: AmountDetails[]
  status: PaymentStatus
  createdDate: Date
  updatedDate?: Date
  totalAmount: number
  products: ProductBase[]
  paymentTokenRes?: {
    transactionId?: string
    paymentId: number
    token: string
  }
  customerType: 'CORPORATE' | 'CONSUMER'
  corpId?: string
  vatEmail?: string
}
export interface AmountDetails {
  key: string
  amount: number
}
export interface ProductBase {
  productCode: string
  name: string
  image?: string
  productType: ProductType
  unitPrice: number
  quantity: number
}
export enum PaymentStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}
